export const PATH = {
  DELAYED_PAYMENT: 'delayed',
}

export const delayedPaymentLinks = {
  delayedPaymentLink: () => `/${PATH.DELAYED_PAYMENT}`,
}
